module.exports = __webpack_public_path__ + "img/icon-clients-blue.effa9fc3.svg";